import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const usePagerStore = defineStore('pagerStore', () => {
  // state
  const total = ref(0)
  const maxPage = ref(0)
  const index = ref(0)
  const limit = ref(0)
  const offset = ref(0)

  // getters
  const getTotalItems = computed(() => total.value)
  const getMaxPage = computed(() => maxPage.value)
  const getLimitPerPage = computed(() => limit.value)
  const getIndex = computed(() => index.value)
  const getOffset = computed(() => offset.value)

  // actions
  async function reset() {
    total.value = 0
    maxPage.value = 0
    limit.value = 0
    index.value = 0
    offset.value = 0
  }

  async function init(data) {
    let _offset = 0
    if (data.offset) {
      _offset = data.offset
    } else if (data.index != 0) {
      _offset = data.limit * data.index
    }
    total.value = data.total
    maxPage.value = data.max
    limit.value = data.limit
    index.value = data.index
    offset.value = _offset
  }

  async function jump(_index) {
    index.value = _index
  }

  async function setOffset(_offset) {
    offset.value = _offset
  }

  return {
    total,
    maxPage,
    index,
    limit,
    offset,
    getTotalItems,
    getMaxPage,
    getLimitPerPage,
    getIndex,
    getOffset,
    reset,
    init,
    jump,
    setOffset,
  }
})
